module.exports = __webpack_public_path__ + "static/media/CS130.34d7f21e.PNG";